export const msisdnWithMask = (msisdn) => {
  if (!msisdn || typeof msisdn !== 'string') {
    return null
  }
  const msisdnOnlyDigits = msisdn.replace(/[^0-9]/g, '')
  if (msisdnOnlyDigits.length < 11) {
    return null
  }
  return '+7 '
    .concat(msisdnOnlyDigits.slice(1, 4))
    .concat(' ')
    .concat(msisdn.slice(4, 7))
    .concat(' ')
    .concat(msisdn.slice(7, 9))
    .concat(' ')
    .concat(msisdn.slice(9, 11))
}

export const pureMsisdn = (msisdn) => {
  if (!msisdn || typeof msisdn !== 'string') {
    return ''
  }
  const msisdnOnlyDigits = msisdn.replace(/[^0-9]/g, '')

  return '7' + msisdnOnlyDigits
}

export const classNameFromCode = (code) => {
  return code && code.replace('_', '-').toLowerCase()
}

export const nexignMsisdn = (msisdn) => (msisdn + '').replace(/^7/, '')

export const regExpCity = /\s\(.+\)/

export const regExpLatinAndCyrillicAndKazakh =
  /^[\u0020-\u007F\u0400-\u044F\u04D8\u04D9\u04B0\u04B1\u0406\u0456\u04A2\u04A3\u0492\u0493\u04AE\u04AF\u049A\u049B\u04E8\u04E9\u04BA\u04BB]+$/
